import { render, staticRenderFns } from "./UseResult.vue?vue&type=template&id=bc02019c&"
import script from "./UseResult.vue?vue&type=script&lang=ts&"
export * from "./UseResult.vue?vue&type=script&lang=ts&"
import style0 from "./UseResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UseResult.vue"
export default component.exports